<template>
  <div v-if="overview">
    <p class="subtitle is-6 has-text-dark">Vehicle overview</p>
    <p class="title is-4 is-size-5-mobile has-text-dark">
      {{ overview.description }}
    </p>
    <div v-if="writeoffCategory" class="notification is-warning is-light">
      <p class="has-text-weight-semibold">
        <span
          >This vehicle could have been recorded as a Category
          {{ writeoffCategory }}. This classification may affect its value. To
          verify the vehicle's current status, we recommend running a provenance
          check.</span
        >
      </p>
      <div class="buttons mt-3">
        <button
          v-if="hasAutoCheck"
          class="button is-warning"
          :class="{ 'is-loading': isAutoCheckLoading }"
          :disabled="isAutoCheckLoading"
          @click="handleAutoCheck"
        >
          Check Vehicle
        </button>
        <button
          v-if="hasMotorCheck"
          class="button is-warning"
          :class="{ 'is-loading': isMotorCheckLoading }"
          :disabled="isMotorCheckLoading"
          @click="handleMotorCheck"
        >
          Check Vehicle
        </button>
      </div>
    </div>
    <claims v-if="permissions.claimsModule" />
    <trade v-else />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as provenance from 'modules/provenance/services'
import * as autocheck from 'modules/autocheck/services'

export default {
  name: 'CompanionOverview',
  components: {
    claims: () => import('./valuation/CompanionValuationsClaims'),
    trade: () => import('./valuation/CompanionValuationsTrade')
  },
  data: () => ({
    isAutoCheckLoading: false,
    isMotorCheckLoading: false
  }),
  mounted() {
    this.$mxp.track('companion_page_load')
  },
  computed: {
    ...mapGetters('companion', ['overview']),
    ...mapGetters('auth', ['permissions', 'hasAutoCheck', 'hasMotorCheck']),
    ...mapGetters('companion', ['writeoffCategory'])
  },
  methods: {
    async handleAutoCheck() {
      this.$mxp.track('companion_carousel_check')
      this.isAutoCheckLoading = true
      try {
        const data = await provenance.precheck({
          value: this.overview.vin,
          type: 'vin'
        })

        this.$modal.open('provenance/precheck', {
          serviceType: 'AutoCheck',
          vrm: data.vrm,
          vin: data.vin,
          description: provenance.buildPreDescription(data),
          mileage: data.mileage,
          submitButtonText: 'Run Check',
          instructionsText:
            'Choose the AutoCheck report options you would like to include.',
          customTitle: `AutoCheck for ${data.vrm}`
        })
      } catch (err) {
        this.$mxp.track('companion_carousel_precheck_failed')
        const msg = err?.response?.data?.error?.message
        this.$notify(msg || 'Currently unable to perform a check')
      } finally {
        this.isAutoCheckLoading = false
      }
    },
    async handleMotorCheck() {
      this.$mxp.track('companion_carousel_check')
      this.isMotorCheckLoading = true
      try {
        const data = await provenance.precheck({
          value: this.overview.vrm,
          type: 'vrm'
        })

        this.$modal.open('provenance/precheck', {
          serviceType: 'Motorcheck',
          vrm: data.vrm,
          vin: data.vin,
          description: provenance.buildPreDescription(data),
          mileage: data.mileage,
          submitButtonText: 'Generate Report',
          instructionsText:
            'Choose the MotorCheck report options you would like to include.',
          customTitle: `MotorCheck for ${data.vrm}`
        })
      } catch (err) {
        this.$mxp.track('companion_carousel_precheck_failed')
        const msg = err?.response?.data?.error?.message
        this.$notify(msg || 'Currently unable to perform a check')
      } finally {
        this.isMotorCheckLoading = false
      }
    }
  }
}
</script>
